export const MIN_WIDTH = 300;
